import type { Filter } from 'components/filters/useStreamFilters'

export const myStreamsEnabled = () => true

export function defaultPrivateStreamFilter(enabled = myStreamsEnabled()): Filter {
    return {
        private: true,
        ...(enabled ? { private_all: true } : {}),
        order: 'time',
    }
}

export function filterForMyStreamsFeature(filter: Filter, enabled = myStreamsEnabled()): Filter {
    if (enabled) return filter

    const hasPersonalScope =
        filter.streams_scope === 'mine' ||
        filter.streams_scope === 'following' ||
        filter.memes_scope === 'mine' ||
        filter.ordinals_scope === 'mine' ||
        filter.private_all === true ||
        filter.private_mentions === true ||
        filter.profile_thread_scope === 'replies'
    if (!hasPersonalScope) return filter

    const nextFilter = { ...filter }

    if (nextFilter.streams_scope === 'mine') delete nextFilter.streams_scope
    if (nextFilter.streams_scope === 'following') delete nextFilter.streams_scope
    if (nextFilter.memes_scope === 'mine') delete nextFilter.memes_scope
    if (nextFilter.ordinals_scope === 'mine') delete nextFilter.ordinals_scope
    if (nextFilter.private_all) delete nextFilter.private_all
    if (nextFilter.private_mentions) delete nextFilter.private_mentions
    if (nextFilter.profile_thread_scope === 'replies') nextFilter.profile_thread_scope = 'posts'

    return nextFilter
}
